function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 0.8,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.859 6.067a.902.902 0 00-.54-.826L11.86 1.129a.901.901 0 00-.72 0L1.682 5.241a.902.902 0 00-.54.826v10.518a.9.9 0 00.554.832l9.895 4.122c.23.097.492.093.72-.011l9.02-4.102a.902.902 0 00.528-.82V6.067zM11.951 9.98L1.309 5.546M11.951 9.98l9.745-4.43M7.165 2.86l9.999 4.754"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.249 12.189a.452.452 0 00-.27-.413l-4.504-1.97a.448.448 0 00-.631.413v3.52c0 .179.106.34.27.413l4.504 1.97a.45.45 0 00.631-.412v-3.521zm2.702 9.449V9.98"
}));

function SvgDeliveryCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23
  }, props), _ref);
}

export default SvgDeliveryCard;